import { Injectable } from '@angular/core';
import { FormBuilderTypeSafe, FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import {
  CreateEPrijemnicaCommand,
  ICreateEPrijemnicaCommand, IEOtpremnicaDto,
  IOdobriOdbaciSefRacunCommand,
  IPredmetStavkeDto,
  IStavkaOtpremniceDto,
  KlasifikacijaRacuna, StavkaOtpremniceDto
} from '@kodit/core/data-api';
import { FormArray, FormControl, Validators } from '@angular/forms';
import { StavkaEoptremniceFormService } from '../form-definitions/stavka-eotpremnice-form.service';
import { BehaviorSubject } from 'rxjs';
import { EOtpremnicaForm, StavkeOtpremniceForm } from '../otpremnice/eotpremnica-form.service';

@Injectable({
  providedIn: 'root',
})
export class KreiranjePrijemniceFormService {
  constructor(
    private _fb: FormBuilderTypeSafe,
    private _stavkeService: StavkaEoptremniceFormService
  ) {}

  public GetFormGroup(
    stavke: StavkaOtpremniceDto[]
  ): FormGroupTypeSafe<ICreateEPrijemnicaCommand> {
    const stavkeArray = this._stavkeService.GetFormArray(stavke);
    this._dodajValidacijuPristiglaKolicina(stavkeArray);

    const form = this._fb.group<ICreateEPrijemnicaCommand>({
      eOtpremniceId: new FormControl(),
      napomena: new FormControl(),
      stavkeDto: stavkeArray,
      brojPrijemnice: new FormControl(),
      magacinId: new FormControl(null, {
        validators: [Validators.required],
      }),
      praviloZaBrojId: new FormControl(null, {
        validators: [Validators.required],
      })
    });

    return form;
  }

  private _dodajValidacijuPristiglaKolicina(stavkeArray: FormArray) {
    stavkeArray.controls.forEach((stavka) => {
      const pristiglaCtrl = stavka.get('pristiglaKolicina');

      if (!pristiglaCtrl) {
        return;
      }

      pristiglaCtrl.setValidators([Validators.required, Validators.min(1)]);
      pristiglaCtrl.updateValueAndValidity({ emitEvent: false });
    });
  }

  form$ = new BehaviorSubject<EPrijemnicaForm>(null);

  set setForm(value: EPrijemnicaForm) {
    this.form$.next(value);
  }

  get getFormObject(): EPrijemnicaForm {
    return this.form$.getValue();
  }

  get getStavkeArray(): FormArray {
    if (!this.getFormObject) {
      return new FormArray([]);
    }
    return this.getFormObject.controls.stavkeDto as FormArray;
  }

    patchPredmetStavke(predmetstavke: IPredmetStavkeDto, stavkaIndex: number) {
      this.getStavkaByIndex(stavkaIndex).controls.predmetStavkeDto?.patchValue(
        predmetstavke
      );
    }

    getStavkaByIndex(index: number): StavkeOtpremniceForm {
      if (!this.getFormObject) {
        return null;
      }

      return this.getFormObject
        .getSafe<IStavkaOtpremniceDto[]>((x) => x.stavkeDto)
        .get([index]) as StavkeOtpremniceForm;
    }
}

export declare type EPrijemnicaForm = FormGroupTypeSafe<ICreateEPrijemnicaCommand> | null;
